<template>
  <div class="container-fluid">
    <div class="w-full rounded overflow-hidden shadow-lg">
        <!-- Contenedor principal para colocar ambas secciones en una fila -->
        <Loader :loading="isLoading" />
        <loader-component v-if="isLoading" :loading="isLoading" />
        <div class="flex  gap-x-0">
            <div class="card" style="flex-grow: 1; width: 100%; height: 100%; flex-shrink: 0; background-color: white; margin: 0; padding: 0;">
                <!-- Tabs Navigation -->
                <div class="card-tabs">
                    <div class="flex border-b">
                        <button 
                            @click="activeTab = 'general'" 
                            :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'general'}"
                            class="px-4 py-2 text-neutral-500 font-medium"
                        >
                            General
                        </button>
                        <button 
                            @click="activeTab = 'ubicacion'" 
                            :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'propiedades'}"
                            class="px-4 py-2 text-neutral-500 font-medium"
                        >
                            Ubicación                        
                        </button>
                        <button 
                            @click="activeTab = 'social'" 
                            :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'social'}"
                            class="px-4 py-2 text-neutral-500 font-medium"
                        >
                            Redes Sociales
                        </button>
                        <button 
                            @click="activeTab = 'propiedades'" 
                            :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'propiedades'}"
                            class="px-4 py-2 text-neutral-500 font-medium"
                        >
                            Propiedades
                        </button>
                        <!--<button 
                            @click="activeTab = 'documentos'" 
                            :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'documentos'}"
                            class="px-4 py-2 text-neutral-500 font-medium"
                        >
                            Documentos
                        </button>-->
                    </div>
                </div>
                <div v-if="activeTab === 'general'" class="w-full h-full p-4 rounded-lg flex">
                    <!-- Sección de perfil a la izquierda -->
                    <div class="flex-0.8 p-4">
                        <div class="card-header text-left py-2">
                            <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                                Perfil
                            </div>
                        </div>
                        <div class="card-body pt-16">
                            <!-- Foto de perfil -->
                            <div class="user-image flex-grow flex items-center justify-center mb-4">
                                <input type="file" id="profile_avatar" style="display: none" @change="updateProfileImage" />
                                <div class="avatar relative">
                                    <img 
                                        :src="imageSrc || defaultProfileImage" 
                                        alt="Avatar" 
                                        id="image_profile" 
                                        class="rounded-full w-26 h-26 mx-auto mb-2" 
                                    />
                                    <!-- Botón para quitar la imagen -->
                                    <button 
                                      v-if="imageSrc"
                                      @click.stop="removeImage"
                                      class="absolute top-2 right-2 bg-white text-red-500 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-500 hover:text-white transition duration-300 z-20"
                                      title="Quitar imagen"
                                    >
                                      &times; <!-- Símbolo de X -->
                                    </button>
                                    <!-- Círculo rosa sobre la imagen de perfil -->
                                    <div class="absolute flex items-center justify-center w-full h-full top-0 left-0 z-10">
                                        <!-- Círculo rosa -->
                                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" class="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-20">
                                            <circle cx="16.5" cy="16.5" r="16.5" fill="#FF4265"/>
                                        </svg>

                                        <!-- Lápiz centrado dentro del círculo -->
                                        <label for="profile_avatar" class="cursor-pointer absolute bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                <g clip-path="url(#clip0_2110_2581)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4649 0.157368C14.3594 0.0519157 14.2164 -0.00732422 14.0672 -0.00732422C13.9181 -0.00732422 13.775 0.0519157 13.6695 0.157368L11.8166 2.01024L15.987 6.18062L17.8399 4.32887C17.8923 4.27662 17.9338 4.21454 17.9622 4.14621C17.9906 4.07787 18.0051 4.00461 18.0051 3.93062C18.0051 3.85663 17.9906 3.78337 17.9622 3.71503C17.9338 3.64669 17.8923 3.58462 17.8399 3.53237L14.4649 0.157368ZM15.1916 6.97599L11.0213 2.80562L3.70877 10.1181H3.94165C4.09083 10.1181 4.2339 10.1774 4.33939 10.2829C4.44488 10.3884 4.50415 10.5314 4.50415 10.6806V11.2431H5.06665C5.21583 11.2431 5.3589 11.3024 5.46439 11.4079C5.56988 11.5134 5.62915 11.6564 5.62915 11.8056V12.3681H6.19165C6.34083 12.3681 6.4839 12.4274 6.58939 12.5329C6.69488 12.6384 6.75415 12.7814 6.75415 12.9306V13.4931H7.31665C7.46583 13.4931 7.6089 13.5524 7.71439 13.6579C7.81988 13.7634 7.87914 13.9064 7.87914 14.0556V14.2885L15.1916 6.97599ZM6.79014 15.3775C6.76647 15.3145 6.75428 15.2479 6.75415 15.1806V14.6181H6.19165C6.04246 14.6181 5.89939 14.5589 5.7939 14.4534C5.68841 14.3479 5.62915 14.2048 5.62915 14.0556V13.4931H5.06665C4.91746 13.4931 4.77439 13.4339 4.6689 13.3284C4.56341 13.2229 4.50415 13.0798 4.50415 12.9306V12.3681H3.94165C3.79246 12.3681 3.64939 12.3089 3.5439 12.2034C3.43841 12.0979 3.37915 11.9548 3.37915 11.8056V11.2431H2.81665C2.74939 11.243 2.68271 11.2308 2.61977 11.2071L2.4184 11.4074C2.36479 11.4614 2.32269 11.5256 2.29465 11.5964L0.0446458 17.2214C0.00372885 17.3236 -0.00628759 17.4356 0.0158383 17.5434C0.0379642 17.6513 0.0912594 17.7503 0.169117 17.8281C0.246974 17.906 0.345969 17.9593 0.45383 17.9814C0.561691 18.0036 0.673674 17.9935 0.775896 17.9526L6.40089 15.7026C6.47162 15.6746 6.53591 15.6325 6.5899 15.5789L6.79014 15.3786V15.3775Z" fill="white"/>
                                                </g>
                                                <defs>
                                                <clipPath id="clip0_2110_2581">
                                                    <rect width="18" height="18" fill="white"/>
                                                </clipPath>
                                                </defs>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                                {{ (name || '') + ' ' + (last_name || '') }}
                              </label>
                              <!-- Botón para recuperar contraseña -->
                              <button  @click="block_user(userId)" class="mt-2 text-blue-500 underline">
                                Recuperar contraseña
                              </button>
                            </div>              
                        </div>
                    </div>
                
                    <!-- Sección de información personal a la derecha -->
                    <div class="flex-1 p-2">
                        <div class="card-header text-left py-2">
                          <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                              Información Personal
                          </div>
                        </div>
                        <form @submit.prevent="saveData">
                          <div class="p-2 flex flex-col-2">
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Ingresa tu nombre</label>
                              <input
                                v-model="name"
                                type="text"
                                required
                                class="w-full rounded-lg border border-gray-300 p-2.5 text-sm bg-white text-box"
                                placeholder="Ingresa tu nombre"
                              />
                            </div>

                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <div class="w-full">
                                <label class="text-style-sm mb-1 block text-sm font-medium text-gray-900 dark:text-white">
                                  Fecha de nacimiento
                                </label>
                                <div class="flex relative">
                                  <VueDatePicker
                                    v-model="birthday"
                                    class="text-box bg-white"
                                    :format="format"
                                    :locale="es"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="p-2 flex flex-col-2">
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Apellido paterno</label>
                              <input
                                v-model="last_name"
                                placeholder="Ingresa tu apellido paterno"
                                type="text"
                                size="sm"
                                class="w-full rounded-lg border border-gray-300 p-2.5 text-sm bg-white text-box"
                                required
                              />
                            </div>
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Apellido Materno</label>
                              <input
                                v-model="last_second_name"
                                placeholder="Ingresa tu apellido materno"
                                type="text"
                                size="sm"
                                class="w-full rounded-lg border border-gray-300 p-2.5 text-sm bg-white text-box"
                                required
                              />
                            </div>
                          </div>

                          <div class="p-2 flex flex-col-2">
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Email</label>
                              <input
                                v-model="email"
                                type="email"
                                required
                                placeholder="Ingresa tu email"
                                class="w-full bg-white text-box border border-gray-300 p-2 rounded-lg"
                              />
                            </div>
                            
                            <!-- Sección del teléfono con lada -->
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Teléfono*</label>
                              
                              <!-- Selector de país -->
                              <div class="custom-select-container mb-2">
                                <div class="selected-option" @click.stop="toggleDropdown">
                                  <div v-if="selectedCountry" class="country-item">
                                    <img 
                                      v-if="getSelectedCountry && getSelectedCountry.flag" 
                                      :src="getSelectedCountry.flag" 
                                      :alt="`Bandera de ${getSelectedCountry.name}`" 
                                      class="flag-img"
                                    />
                                    <span>{{ getSelectedCountry ? getSelectedCountry.name : '' }} ({{ selectedCountry }})</span>
                                  </div>
                                  <div v-else class="placeholder">Selecciona un país</div>
                                  <div class="arrow-down"></div>
                                </div>

                                <!-- Dropdown options -->
                                <div class="dropdown-menu" v-if="isDropdownOpen">
                                  <div 
                                    v-for="country in filteredCountries" 
                                    :key="country.dial_code"
                                    class="country-option"
                                    @click="selectCountry(country.dial_code)"
                                  >
                                    <img 
                                      v-if="country.flag" 
                                      :src="country.flag" 
                                      :alt="`Bandera de ${country.name}`" 
                                      class="flag-img"
                                    />
                                    <span>{{ country.name }} ({{ country.dial_code }})</span>
                                  </div>
                                </div>
                              </div>

                              <!-- Input del número de teléfono -->
                              <input
                                type="tel"
                                v-model="phoneNumber"
                                placeholder="Ingresa tu número de teléfono"
                                required
                                @input="onlyNumbers"
                                @blur="validatePhoneNumber"
                                :class="{
                                  'w-full bg-white text-box border border-gray-300 p-2 rounded-lg': !phoneError,
                                  'w-full bg-red-50 text-box border border-red-500 p-2 rounded-lg': phoneError
                                }"
                              />
                              <p v-if="phoneError" class="mt-1 text-sm font-medium text-red-600">{{ phoneError }}</p>
                            </div>
                          </div>

                          <div class="p-2 flex flex-col-2">
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Compañía</label>
                              <select
                                class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box"
                                v-model="user.company_id"
                                required
                              >
                                <option value="" disabled selected>Selecciona una compañía</option>
                                <option v-for="company in companies" :key="company.id" :value="company.id">
                                  {{ company.name }}
                                </option>
                              </select>
                            </div>
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-style-sm mb-1">Cargo</label>
                              <select class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" v-model="user.position_id">
                                <option value="0">Selecciona un cargo</option>
                                <option v-for="cargo in cargos" :key="cargo.id" :value="cargo.id">
                                  {{ cargo.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="p-2 flex flex-col-2">
                            <div class="flex flex-1 flex-col p-2 text-gray-900" style="flex: 0 0 50%;">
                              <label class="text-style-sm mb-1">Plan</label>
                              <select 
                                class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" 
                                v-model="user.plan_id" 
                                required
                              >
                                <option value="" disabled selected>Selecciona un plan</option>
                                <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                                  {{ plan.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="flex-auto">
                            <label
                              for="phone"
                              class="block mb-2 text-sm font-medium text-gray-900"
                            >
                              Descripción
                            </label>
                            <ckeditor
                              v-model="aboute_me"
                              :editor="editor"
                              :config="editorConfig"
                            />
                          </div>
                          <div class="p-2 flex flex-col">
                            <div class="flex flex-1 flex-col p-2 text-gray-900">
                              <label class="text-box mb-1">
                                <input
                                  type="checkbox"
                                  id="block_user"
                                  v-model="blockUser"
                                  class="form-check-input"
                                />
                                Bloquear
                              </label>
                            </div>
                          </div>

                          <div class="p-2 flex flex-col">
                            <div class="flex flex-1 justify-end items-end border-gray-300 p-2 text-gray-900">
                              <fwb-button 
                                class="bg-tuin-100 hover:bg-tuin-100" 
                                size="xl"
                                type="submit"
                                :disabled="isSubmitting"
                              >
                                <!--<span v-if="isSubmitting">Guardando...</span>-->
                                <span>Actualizar Perfil</span>
                              </fwb-button>
                            </div>
                          </div>
                        </form>
                    <div v-if="successMessage" class="user-alert">
                      <div class="user-alert-content">
                        <div class="user-alert-text">
                          {{ successMessage }}
                        </div>
                      </div>
                      <div class="w-4 h-4 relative"></div>
                    </div>
                    <div v-if="errorMessage" class="user-alert-error">
                      <div class="user-alert-content">
                        <div class="user-alert-text">
                          {{ errorMessage }}
                        </div>
                      </div>
                      <div class="w-4 h-4 relative"></div>
                    </div>
                    <ResetPassword_modal
                      :isVisible="showBlockModal"
                      @confirm="reenviar_email(userId)"
                      @cancel="closeModal"
                    />
                    <head>
                            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                    </head>
                    </div>
                </div>
                <div v-if="activeTab === 'social'">
                    <social-networks-form 
                      :company-id="companyId" 
                      @social-data-updated="handleSocialDataUpdate"
                    ></social-networks-form>
                </div>
                <div v-if="activeTab === 'ubicacion'">
                    <FormLocationComponent
                      :property-id="userId" 
                      :resp="data_broker"
                      Type="agent" 
                    />
                </div>
                <div v-if="activeTab === 'propiedades'">
                    <Properties-list 
                      :company-id="companyId" 
                      @social-data-updated="handleSocialDataUpdate"
                    ></Properties-list >
                </div>
                <div v-if="activeTab === 'documentos'">
                    <Documentos
                      :company-id="companyId" 
                      @social-data-updated="handleSocialDataUpdate"
                    ></Documentos >
                </div>
            </div>
        </div>
    </div>
</div> 
</template>

<script setup>
import { FwbButton } from "flowbite-vue";
import { ref, computed, onMounted } from "vue";
import { es } from 'date-fns/locale';
import VueDatePicker from "@vuepic/vue-datepicker";
import axios from "axios";
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import 'vue-toastification/dist/index.css';
import Loader from '@/components/loaderComponent.vue';
import defaultProfileImage from '@/assets/imgs/1.png';
import ResetPassword_modal from './modal/ResetPassword_modal.vue';
import SocialNetworksForm from '@/components/advisor/NetworksAdvisorComponent.vue'; // Import the new component
import PropertiesList from '@/components/advisor/PropertiesAdvisorComponent.vue'; // Import the new component
import Documentos from '@/components/advisor/DocumentsAdvisorComponent.vue'; // Import the new component
import { useRouter } from "vue-router";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import FormLocationComponent from "./FormLocationComponent.vue";

// Obtener la tienda de Vuex
const store = useStore();
const showBlockModal = ref(false); // Controla la visibilidad del modal
const isLoading = ref(true); // Inicializamos isLoading
const isSubmitting = ref(false); // Control de envío
const activeTab = ref('general'); // Default active tab
//const selectedUserId = ref(null);
let session = computed(() => store.getters.getUserSession);
const route = useRoute();
let userId = computed(() => route.params.id);

let selectedRoles = ref([]);
let router = useRouter();
// Variables reactivas
let name = ref(null);
let birthday = ref();
let email = ref();
let aboute_me = ref(null);
//let phone = ref();
let  imageSrc = ref(null);
let  blockUser = ref(false);
// Computed que devuelve la URL de la imagen a mostrar
let last_name = ref();
let last_second_name = ref();
let step = ref(1);
let profile = ref();
let companies = ref([]); // Declaración de companies
let user = ref({ company_id: null });
let cargos = ref([]); // Declaración de cargos
let plans = ref([]); // Declaración de planes
let accounts = ref([]); // Declaración de cuentas
let data_broker = ref({});

// Nuevas variables para el teléfono con lada
const phoneNumber = ref('');
const phoneError = ref('');
const countryCodes = ref([]);
const selectedCountry = ref("");
const isDropdownOpen = ref(false);

const successMessage = ref('');
const errorMessage = ref('');

// Computed property para obtener el país seleccionado completo
const getSelectedCountry = computed(() => {
  return countryCodes.value.find(country => country.dial_code === selectedCountry.value);
});

// Países filtrados ordenados alfabéticamente
const filteredCountries = computed(() => {
  return [...countryCodes.value].sort((a, b) => a.name.localeCompare(b.name));
});

// Formato de fecha
const format = (birthday) => {
  if (!birthday) return "";
  // Asegúrate de usar la hora UTC para evitar el desfase de zona horaria
  const date = new Date(birthday);
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1;
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

const editor            = ref(ClassicEditor);
const editorConfig = {
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "link",
        "blockQuote",
        "|",
        "undo",
        "redo",
        "|",
        "numberedList",
        "bulletedList",
        "|",
        "alignment",
        "indent",
        "outdent",
        "|",
        "insertHR",
        "code",
        "codeBlock",
        "removeFormat",
        "|",
        "fontSize",
        "fontFamily",
        "fontColor",
        "backgroundColor",
        "highlight",
      ],
      colorButton_enableMore: true,
      contentsCss: [
        "body { background-color: white !important; color: black !important; }"
      ]
    };

// Funciones para el selector de país
const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const selectCountry = (dialCode) => {
  selectedCountry.value = dialCode;
  isDropdownOpen.value = false;
};

// Función para cerrar el dropdown cuando se hace clic fuera
const closeDropdown = (e) => {
  const container = document.querySelector('.custom-select-container');
  if (container && !container.contains(e.target)) {
    isDropdownOpen.value = false;
  }
};

// Función para permitir solo números
const onlyNumbers = (event) => {
  phoneNumber.value = event.target.value.replace(/[^0-9]/g, '');
};

// Validar número de teléfono
const validatePhoneNumber = () => {
  phoneError.value = '';
  
  if (!phoneNumber.value) {
    phoneError.value = 'Campo obligatorio';
    return false;
  }

  // Validar que el número tenga exactamente 10 dígitos
  const phoneRegex = /^\d{10}$/;
  if (!phoneRegex.test(phoneNumber.value)) {
    phoneError.value = 'El número debe tener exactamente 10 dígitos';
    return false;
  }

  return true;
};

// Verificar si el teléfono ya existe
const checkPhoneExists = async () => {
  if (!validatePhoneNumber()) {
    return { exists: false, error: true };
  }

  const token = session.value.token_api;
  const completePhone = phoneNumber.value;
  const countryCode = selectedCountry.value;
  
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/check-phone-exists`,
      {
        params: {
          phone: completePhone,
          country_code: countryCode,
          user_id: userId.value // Para excluir al usuario actual
        },
        headers: {
          Authorization: `Bearer ${token.trim()}`,
        },
      }
    );
    
    return { exists: response.data.exists, error: false, message: response.data.message };
  } catch (err) {
    console.error("Error al verificar el teléfono:", err);
    const errorMessage = err.response?.data?.message || "El teléfono ya está registrado.";
    return { exists: false, error: true, message: errorMessage };
  }
};

// Cargar códigos de país desde la API
// Cargar códigos de país desde la API
const loadCountryCodes = async () => {
  const token = session.value ? session.value.token_api : null;

  if (!token) {
    showToast("No se encontró la sesión del usuario. Vuelve a iniciar sesión.");
    return;
  }

  const url = `${process.env.VUE_APP_API_BASE_URL}/get-country-preferences`;
  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.trim()}`,
    },
  };

  try {
    const response = await axios.get(url, options);
    countryCodes.value = response.data;
    console.log("Códigos de país activos cargados:", countryCodes.value);

    // Si no hay código de país seleccionado ya (desde getProfile)
    if (countryCodes.value.length > 0 && !selectedCountry.value) {
      // Primero intentar con +52 (México) como predeterminado
      const mexicoCountry = countryCodes.value.find(c => c.dial_code === '+52');
      
      if (mexicoCountry) {
        selectedCountry.value = '+52';
      } else {
        // Si no está México, usar el primer país de la lista
        selectedCountry.value = countryCodes.value[0].dial_code;
      }
    }
  } catch (err) {
    console.error("Error al cargar códigos de país:", err);
    showToast("No se pudieron cargar los códigos de país.");
  }
};
const closeModal = () => {
showBlockModal.value = false; // Cierra el modal
};
const handleSocialDataUpdate = (socialData) => {
    // You can add logic here to handle social data if needed
    console.log('Social data updated:', socialData);
};
console.log(imageSrc)
const removeImage = () => {
imageSrc.value = '';
};
// Obtener perfil
async function getProfile() {
try {
  let options = {
    headers: {
      'Authorization': `Bearer ${session.value.token_api}`
    }
  };

  const response = await axios.get(
    `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${userId.value}`, options
  );

  if (response.status === 401) {
    store.dispatch('clearUserSession');
  }
  
  if (response.status === 200) {
    data_broker.value = response;
    profile.value = response.data.resp.info;
    name.value = response.data.resp.info.name;
    last_name.value = response.data.resp.info.last_name;
    last_second_name.value = response.data.resp.info.last_second_name;
    email.value = response.data.resp.info.email;
    aboute_me.value = response.data.resp.info.about_me;
    birthday.value = response.data.resp.info.birthday;
    user.value.company_id = response.data.resp.info.company_id;
    user.value.plan_id = response.data.resp.info.plan_id;
    user.value.position_id = response.data.resp.info.position_id;
    blockUser.value = response.data.resp.info.status === 'block';
    
    // MODIFICACIÓN: Manejo del teléfono con lada
    if (response.data.resp.info.phones && response.data.resp.info.phones.length > 0) {
      const phoneInfo = response.data.resp.info.phones[0];
      selectedCountry.value = phoneInfo.country_code;
      phoneNumber.value = phoneInfo.phone_number;
    } else if (response.data.resp.info.phone) {
      phoneNumber.value = response.data.resp.info.phone;
    }
    
    // Usar el phone_country_code si está disponible y selectedCountry aún no se ha establecido
    if (!selectedCountry.value && response.data.resp.phone_country_code) {
      selectedCountry.value = response.data.resp.phone_country_code;
    }

    const profileAvatar = response.data.resp.info.profile_avatar;
    if (profileAvatar) {
      imageSrc.value = `${profileAvatar}`;
    } else {
      imageSrc.value = null;
    }

    selectedRoles.value = response.data.resp.info.roles.map(role => role.id);
  }
  isLoading.value = false; 
} catch (error) {
  console.error("Error fetching data:", error);
}
}

const reenviar_email = async (userId) => {
try {
  const options = {
    headers: {
      'Authorization': `Bearer ${session.value.token_api}`,
      'Content-Type': 'application/json'
    }
  };

  const data = { user_id: userId };

  const response = await axios.post(
    `${process.env.VUE_APP_API_BASE_URL}/broker/profile/resend-activation-email/${userId}`,
    data,
    options
  );

  console.log('Respuesta del servidor:', response.data);

  if (response.status === 200) {
    showToast('Correo reenviado correctamente'); 
  } else {
    showToast('Hubo un error al reenviar.');
  }
} catch (error) {
  console.error('Error al reenviar correo:', error);
  showToast('Hubo un error inesperado.');
}
};
async function updateProfileImage(event) {
  const file = event.target.files[0];
  if (file) {
    // Similar al de portada, puedes cargar la imagen en tu servidor o mostrarla localmente
    const reader = new FileReader();
    reader.onload = () => {
      imageSrc.value = reader.result;   // Actualiza la imagen en la vista
      console.log(imageSrc)
    };
    reader.readAsDataURL(file);  // Convierte la imagen a base64
  }
}
// Obtener compañías
async function fetchCompanies() {
try {
  let options = {
    headers: {
      'Authorization': `Bearer ${session.value.token_api}`
    }
  };
  const response = await axios.get(
    `${process.env.VUE_APP_API_BASE_URL}/companies`, options
  );

  if (response.status === 401) {
    store.dispatch('clearUserSession');
  }

  if (response.status === 200 && response.data?.resp?.companies) {
    companies.value = response.data.resp.companies; // Cambia esto
  } else {
    console.error("Error en la respuesta de la API: estructura inesperada");
  }
} catch (error) {
  console.error("Error al obtener las compañías:", error);
}
}


//obtener los cargos
async function fetchCargos() {
try {
  let options = {
    headers: {
      'Authorization': `Bearer ${session.value.token_api}`
    }
  };
  const response = await axios.get(
    `${process.env.VUE_APP_API_BASE_URL}/cargos`, options
  );

  if (response.status === 401) {
    store.dispatch('clearUserSession');
  }

  // Accede a los cargos en response.data.cargos
  if (response.status === 200 && response.data?.cargos) {
    cargos.value = response.data.cargos; 
  } else {
    console.error("Error en la respuesta de la API: estructura inesperada");
  }
} catch (error) {
  console.error("Error al obtener los cargos:", error);
}
}

//obtener los cargos
async function fetchPlanes() {
try {
  let options = {
    headers: {
      'Authorization': `Bearer ${session.value.token_api}`
    }
  };
  const response = await axios.get(
    `${process.env.VUE_APP_API_BASE_URL}/planes`, options
  );

  if (response.status === 401) {
    store.dispatch('clearUserSession');
  }

  // Accede a los cargos en response.data.cargos
  if (response.status === 200 && response.data?.plans) {
    plans.value = response.data.plans; 
  } else {
    console.error("Error en la respuesta de la API: estructura inesperada");
  }
} catch (error) {
  console.error("Error al obtener los planes:", error);
}
}

//obtener los cargos
async function fetchAccounts() {
try {
  let options = {
    headers: {
      'Authorization': `Bearer ${session.value.token_api}`
    }
  };
  const response = await axios.get(
    `${process.env.VUE_APP_API_BASE_URL}/account`, options
  );

  if (response.status === 401) {
    store.dispatch('clearUserSession');
  }

  // Accede a los cargos en response.data.cargos
  if (response.status === 200 && response.data?.accounts) {
    accounts.value = response.data.accounts; 
  } else {
    console.error("Error en la respuesta de la API: estructura inesperada");
  }
} catch (error) {
  console.error("Error al obtener los planes:", error);
}
}

// Llama a la función para obtener los roles al montar el componente
onMounted(async () => {
await fetchCompanies();
await fetchCargos();
await fetchPlanes();
await fetchAccounts();
await loadCountryCodes(); // AGREGAR ESTA LÍNEA
await getProfile();
document.addEventListener('click', closeDropdown); // AGREGAR ESTA LÍNEA
});


// Función para guardar datos
async function saveData() {
  // Limpiar mensajes previos
  successMessage.value = '';
  errorMessage.value = '';
  
  // Validar teléfono antes de guardar
  if (!validatePhoneNumber()) {
    showErrorToast('Por favor corrige los errores en el formulario');
    return;
  }

  // Verificar si el teléfono ya existe
  const { exists, error: checkError, message } = await checkPhoneExists();
  
  if (checkError) {
    showErrorToast(message || 'Error al verificar el teléfono');
    return;
  }
  
  if (exists) {
    showErrorToast('El número de teléfono ya está registrado');
    return;
  }

  if (session.value.step < 3) {
      step.value = 1;
  } else {
      step.value = session.value.step;
  }

  // Incluir el código de país y teléfono separado
  let params = {
      'name': name.value,
      'birthday': birthday.value ? birthday.value : null, 
      'email': email.value,
      'about_me': aboute_me.value,
      'phone': phoneNumber.value, // Solo el número sin lada
      'country_code': selectedCountry.value, // Código de país separado
      'last_name': last_name.value,
      'last_second_name': last_second_name.value,
      'step': step.value,
      'company_id': user.value.company_id,
      'plan_id': user.value.plan_id,
      'position_id': user.value.position_id,
      'account_id': user.value.account_id,
      'rol': selectedRoles.value,
      'source': 'broker',
      'blockUser': blockUser.value ? 1 : 0,
      'status': blockUser.value ? 'block' : 'active',
  };

  try {
      isSubmitting.value = true; // Activar estado de carga

      let options = {
        headers: {
            'Authorization': `Bearer ${session.value.token_api}`
        }
      };

      const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${userId.value}/update-general`,
        params,
        options
      );

      if (response.status == 200) {
        showToast('Datos guardados correctamente');
        
        if (session.value.step < 3) {
            session.value.step = 1;
            router.push({ name: "" });
            getProfile();
        }

        // Manejo de imagen
        if (imageSrc.value) {
            try {
              let formData = new FormData();
              formData.append('email', email.value);
              formData.append('user_id', userId.value);
              
              if (imageSrc.value instanceof File) {
                formData.append('profile_avatar', imageSrc.value);
              } else if (typeof imageSrc.value === 'string' && imageSrc.value.startsWith('data:image')) {
                const profileAvatarFile = base64ToFile(imageSrc.value, 'profile_avatar.jpg');
                formData.append('profile_avatar', profileAvatarFile);
              }

              const imageResponse = await axios.post(
                `${process.env.VUE_APP_API_BASE_URL}/broker/profile/update-account`,
                formData,
                options
              );

              if (imageResponse.status == 200) {
                showToast('Imagen de perfil guardada correctamente');
              } else {
                showErrorToast('Error al guardar la imagen de perfil');
              }
            } catch (imageError) {
              console.error("Error al guardar la imagen:", imageError);
              showErrorToast('Error al guardar la imagen de perfil');
            }
        }
      } else {
        showErrorToast('Error al guardar los datos del perfil');
      }
  } catch (error) {
      console.error("Error al guardar los datos:", error);
      
      // Manejo más específico de errores
      if (error.response) {
        // Error de respuesta del servidor
        const statusCode = error.response.status;
        const errorData = error.response.data;
        
        if (statusCode === 422) {
          // Errores de validación - extraer mensajes específicos
          if (errorData.error && typeof errorData.error === 'object') {
            // Obtener el primer error específico
            const errorMessages = [];
            for (const field in errorData.error) {
              if (Array.isArray(errorData.error[field])) {
                errorMessages.push(...errorData.error[field]);
              }
            }
            
            if (errorMessages.length > 0) {
              showErrorToast(errorMessages[0]); // Mostrar el primer mensaje de error
            } else {
              showErrorToast('Error de validación en los datos');
            }
          } else if (errorData.message) {
            showErrorToast(errorData.message);
          } else {
            showErrorToast('Error de validación en los datos');
          }
        } else if (statusCode === 401) {
          showErrorToast('Sesión expirada. Por favor, inicia sesión nuevamente');
          store.dispatch('clearUserSession');
        } else if (statusCode === 404) {
          showErrorToast('Usuario no encontrado');
        } else if (statusCode >= 500) {
          showErrorToast('Error del servidor. Intenta nuevamente más tarde');
        } else {
          showErrorToast(errorData.message || 'Error al guardar los datos');
        }
      } else if (error.request) {
        // Error de red
        showErrorToast('Error de conexión. Verifica tu internet e intenta nuevamente');
      } else {
        // Otro tipo de error
        showErrorToast('Error inesperado al guardar los datos');
      }
  } finally {
      isSubmitting.value = false; // Desactivar estado de carga
  }
}
const base64ToFile=(base64Data, filename)=> {
let arr = base64Data.split(',');
let mime = arr[0].match(/:(.*?);/)[1];
let bstr = atob(arr[1]);
let n = bstr.length;
let u8arr = new Uint8Array(n);

while (n--) {
  u8arr[n] = bstr.charCodeAt(n);
}

return new File([u8arr], filename, { type: mime });
}
const showToast = (message) => {
  successMessage.value = message;
  setTimeout(() => {
    successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  }, 3000);
}

// Función para mostrar mensajes de error
const showErrorToast = (message) => {
  errorMessage.value = message;
  setTimeout(() => {
    errorMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  }, 3000);
}


// Computed properties
//const isRoleAdminOrManager = computed(() => {
//  return session.value && (session.value.role === 'admin' || session.value.role === 'manager');
//});

</script>


<style scoped>
  /* Label personalizado */
  ::v-deep .custom-label label,
  ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
    @apply text-white;
  }

  /* Fondo del body */
  body {
    background-color: #ffffff !important;
  }

  /* Imagen de usuario */
  .user-image {
    position: relative;
    margin-top: -60px;
    margin-bottom: 1rem;
  }
  .avatar {
    @apply rounded-full w-32 h-32 border-4 border-white inline-block overflow-hidden;
  }

  /* Roles en contenedor flexible */
  .roles-container {
    @apply flex flex-wrap gap-4;
  }

  /* Checkbox seleccionado */
  .form-check-input:checked {
    @apply bg-pink-500 border-pink-500;
  }
  .custom-select-container {
    position: relative;
    width: 100%;
    user-select: none;
  }

  .selected-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: white;
    cursor: pointer;
  }

  .country-item, .country-option {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .placeholder {
    color: #666;
  }

  .arrow-down {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #666;
    margin-left: 8px;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 8px 8px;
    z-index: 100;
  }

  .country-option {
    padding: 8px 12px;
    cursor: pointer;
  }

  .country-option:hover {
    background-color: #f5f5f5;
  }

  .flag-img {
    width: 24px;
    height: auto;
    vertical-align: middle;
    border: 1px solid #ddd;
  }

  .error-message {
    color: red;
  }
</style>
